import purify from "isomorphic-dompurify";

/**
 * Custom sanitizer that uses DOMPurify and additional dangerous pattern checking
 */
export const sanitizeUrlValue = (value: string): string  =>  {
    if (typeof value !== 'string') {
        return '';
    }

    const purifiedValue = purify.sanitize(value);
    const lowerValue = purifiedValue.toLowerCase();
    const dangerousPatterns = [
        /javascript:/g,
        /vbscript:/g,
        /data:/g,
        /on\w+=/g,
        /style=.*?expression\(/g
    ];

    const isSafe = !dangerousPatterns.some(pattern => pattern.test(lowerValue));

    return isSafe ? purifiedValue : '';
}

/**
 * Sanitizes a relative URL.
 * @param url - the URL to sanitize
 * @returns the sanitized URL
 */
export function sanitizeRelativeUrl(url: string) {
    if (!url) {
        return url;
    }
    if (url.indexOf('http') === -1 && !url.startsWith('/')) {
        url = '/' + url;
    }
    return url;
}
